<template>
  <div class="container"></div>
</template>

<script>
export default {
  name: 'UserProfileDefaultBanner',
};
</script>

<style lang="scss" scoped>
@import '@/assets/youpaired-colors.scss';

.container {
  background-color: $default-banner;
  height: 20rem;
  width: 100%;
  max-height: 40rem;
  background-size: cover;
}
</style>
